<template>
  <div class="put_import_container" :class="{ 'full_page': showSecPage }">
    <div v-show="!showSecPage" style="height: 100%;">
      <div class="p_i_left">
        <ImportCondition ref="formCmpImport" v-if="isExport" :config="apiObj" :importStatus.sync="importStatus"
          @search="importExcelReq" @progress="uploadProgress"></ImportCondition>
        <OrderFormPoint v-else @submit="clickSearch" ref="formCmp"></OrderFormPoint>
      </div>
      <div class="p_i_right" v-show="!send">
        <div class="p_i_import" v-if="importStatus === 0 && isExport">
          <img src="../../assets/import_guid_img.png" class="import_img" />
        </div>
        <div class="p_i_import" v-else-if="importStatus === 1">
          <div class="progress_box">
            <span class="file_name"><i class="iconfont icon-wodedingdan"></i>{{ fileObj.name }}</span>
            <el-progress :percentage="fileObj.progress"></el-progress>
            <span class="close_btn">x</span>
          </div>
        </div>
        <div class="p_i_result" v-else-if="importStatus === 2 || communityList.length">
          <div class="r_header r_b_search">
            <div class="smart_sort radio_line" v-if="isCondition">
              <i class="el-icon-sort"></i>
              排序:
              <el-radio v-model="smartSortType" label="1" class="first">推荐度优先</el-radio>
              <!-- <span class="line"></span>
              <el-radio v-model="smartSortType" label="2">空刊优先</el-radio>
              <span class="line"></span>
              <el-radio v-model="smartSortType" label="3">流量密度</el-radio>
              <i class="flow" @click="flowType = !flowType" v-if="smartSortType == 3">
                <span :class="flowType ? 'grey' : ''">↑</span>
                <span :class="!flowType ? 'grey' : ''">↓</span>
              </i> -->
            </div>
            <div class="s_input"
              :class="{ 'highlight': searchHightLight, 'no-time': isSmallSn, 'is_condition': isCondition }">
              <el-input v-model="communityKey" type="text" clearable ref="search-community" placeholder="输入小区名称"
                prefix-icon="iconfont icon-dingdanxiangqing-sousuo" @change="filterCommunityData"
                @focus="searchHightLight = true" @blur="searchHightLight = false" />
              <i class="search_text" @click="filterCommunityData">搜索</i>
            </div>
            <!--  @focus.once="addKeyupEvent" @blur="() => { searchHightLight = false; filterCommunityData() }" -->
            <div class="fr" v-if="isExport">
              <p class="s_msg">
                <b>结果： </b>成功 <em class="hl">{{ excelResult.successCount || 0 }}</em> ，
                失败 {{ excelResult.failCount || 0 }} ，缺货 {{ excelResult.shortageCount || 0 }}
              </p>
              <el-button type="text" class="s_button" @click="getNbhdExcelByCondition">查看详情</el-button>
            </div>
          </div>
          <div class="r_body" ref="scroll" :class="{ 'is_condition': isCondition }">
            <div class="r_b_ul" :class="{ empty: !showNbhdList.length }" ref="scrollList" :style="listFillPadding">
              <div class="r_b_list" v-for="(item, i) in showNbhdList" :key="i">
                <el-checkbox v-model="item.checked" @change="changeCommunityHandler(item)"
                  :indeterminate="!!item.allSelectDeviceCount && (item.allSelectDeviceCount !== item.allDeviceCount)"></el-checkbox>
                <CommunityInfo :data.sync="item" :is-export="isExport" :showByte="showByte"
                  :smartSortType="smartSortType" @change="childChangeReq" @showSight="showSight"></CommunityInfo>
              </div>
            </div>
          </div>
          <div class="sort_num radio_line">智能选取:
            <el-radio v-model="smarSortNumRadio" label="1" class="first">指定总量</el-radio>
            <span v-show="smarSortNumRadio === '1'">
              <el-input-number class="num_input" size="mini" placeholder="请输入" controls-position="right" step-strictly
                :min="0" :max="999999999" v-model="smartNum" @keyup.enter="smartSearch">
              </el-input-number>台
              <span class="sort_btn" @click="smartSearch">
                生成方案<i class="iconfont icon-shuaxin"></i>
              </span>
            </span>
            <span class="line"></span>
            <el-radio v-model="smarSortNumRadio" label="2">分散投放</el-radio>
            <span v-show="smarSortNumRadio === '2'">按每个
              <el-select v-model="smarSortNumType" size="mini">
                <el-option label="小区" value="NBHD_COUNT">小区</el-option>
                <el-option label="楼幢" value="BUILDING_COUNT">楼幢</el-option>
                <el-option label="单元" value="NUIT_COUNT">单元</el-option>
              </el-select>
              <i class="el-icon-caret-bottom"></i>
              <el-input-number class="num_input ml" size="mini" placeholder="不限" controls-position="right" step-strictly
                :min="0" :max="999999999" v-model="smartNum" @keyup.enter="smartSearch">
              </el-input-number>台
              <span class="sort_btn" @click="smartSearch">
                生成方案<i class="iconfont icon-shuaxin"></i>
              </span>
            </span>
          </div>
          <div class="r_footer">
            <el-checkbox v-model="allSelect" :indeterminate="sumData.allWindow > sumData.window && sumData.window !== 0"
              @change="changeAllSelectHandler">
              <span class="dark r_checkbox_label">全选</span>
            </el-checkbox>
            <p class="r_f_price">
              <em class="hl">￥{{ discountMoney | tofixed2 }}</em><span class="del">￥{{ chooseAllMoney | tofixed2
                }}</span>
              <span class="convert" v-if="!isSmallSn && (!isCpd || isSpeUser)" @click="isShowConvert = true">
                <i class="iconfont icon-jisuan" style="margin-right: 3px;position: relative;top: 1px;"></i>换算
              </span>
            </p>
            <p class="r_f_msg">
              覆盖<em class="dark">{{ allChooseNum.nbhd }}</em>个小区、
              <em class="dark">{{ allChooseNum.device }}</em>个屏
              <template v-if="allChooseNum.people !== undefined && allChooseNum.people > -1">
                、<em class="dark">{{ allChooseNum.people }}</em>人
              </template>
              <template v-if="!isSmallSn">
                <template v-if="isCpm">
                  <template v-if="payWay == 'cpmT'">
                    、预计流量<em class="dark">{{ cpmAccountNum }}</em>千人次
                  </template>
                  <template v-if="payWay == 'cpmL'">
                    、预计流量<em class="dark">{{ cpmAccountNum }}</em>千人次、预计投放<em class="dark">{{ cpmLPutLongTime }}</em>
                  </template>
                </template>
                <template v-if="payWay == 'pkg'">
                  、预计流量<em class="dark" style="color: #FF3973;">{{ cpmAccountNum }}</em>/<em
                    class="dark">{{ searchReqObj.pkgChooseFlow ? (searchReqObj.pkgChooseFlow / 1000).toFixed(2) :
                    '0.00'}}</em>千人次
                </template>
              </template>
            </p>
            <el-button class="f_import_button" @click="sendOrder">{{ isExport ? '导入投放' : '立即投放' }}</el-button>
          </div>
        </div>
        <div class="p_i_import" v-else>
          <img src="../../assets/choose_condition.png" class="import_img" />
        </div>
      </div>
    </div>
    <ImportResultDialog :visible.sync="importResultVisible" :import-type="importType" :uuid="uuid"></ImportResultDialog>
    <div class="sec_page" v-if="showSecPage">
      <OrderConfirm v-if="send" :options="orderOptions" @confirmBack="send = false" :import-type="importType"
        :uuid="uuid">
      </OrderConfirm>
      <BytesInsight v-if="sightId" :id="sightId" :name="sightName" @back="sightId = ''; sightName = ''"></BytesInsight>
    </div>
    <ConvertDialog v-model="isShowConvert" :cpmNum="chooseCpmAccountNum" :devices="sumData.window" :days="covertDays">
    </ConvertDialog>
    <fix-centerv1 v-model="showPkgPop" @close="showPkgPop = false" w="400" h="300">
      <span slot="title">
        <span v-if="pkgChooseMore10">超额提示</span>
        <span v-if="pkgChooseLess10">差额提示</span>
      </span>
      <div class="pkgpop_main" slot="main">
        <div v-if="pkgChooseMore10">
          <div>尊敬的星悦会员用户，您当前所选点位的预估流量已经超过了产品定额总量的10%；</div>
          <div style="margin-top: 10px;">您可以通过<span>增加套餐量</span>/<span>更换点位</span>/<span>缩短时间</span>，来达到流量标准；</div>
        </div>
        <div v-if="pkgChooseLess10">
          <div>尊敬的星悦会员用户，您当前所选点位的预估流量仍有超过10%的可用套餐余量；</div>
          <div style="margin-top: 10px;">您可以通过<span>减少套餐量</span>/<span>更换点位</span>/<span>增加时间</span>，来达到流量标准；</div>
        </div>
      </div>
      <template slot="btm">
        <div class="fix-btn red" @click="showPkgPop = false">返回修改</div>
        <div class="fix-btn" @click="showPkgPop = false; send = true">继续下单</div>
      </template>
    </fix-centerv1>
  </div>
</template>

<script>
import { getIntelligentDeviceByExcel } from '@/utils/api'
import { deepClone } from '@/utils/functions'
import searchLabelsMix from '@/utils/searchLabelsMix'
import searchPointMix from '@/utils/mixins/searchPointMix'
import OrderFormPoint from './components/OrderFormPoint' // 首次会展示 此组件就暂时不懒加载了

export default {
  name: 'PutOrderExcelImport',
  props: ['isExport', 'importType'],
  mixins: [searchLabelsMix, searchPointMix],
  components: {
    CommunityInfo: () => import('./components/CommunityInfo'),
    ImportResultDialog: () => import('./dialog/ImportResult'),
    OrderConfirm: () => import('@/views/order/OrderConfirm'),
    OrderFormPoint,
    ImportCondition: () => import('./components/ImportCondition'),
    ConvertDialog: () => import('./dialog/ConvertDialog'),
    BytesInsight: () => import('./BytesInsight')
  },
  filters: {
    tofixed2(d) {
      return new Number(d).toFixed(2)
    }
  },
  data() {
    return {
      importStatus: 0, // 0: 未导入， 1: 导入中 2: 导入完成
      communityList: [],
      searchHightLight: false,
      importResultVisible: false,
      fileObj: {},
      searchCondition: {
        endDate: '',
        startDate: '',
        frequencyList: [],
        contentTime: ''
      },
      excelResult: {},
      uuid: '',
      sumData: {
        price: 0,
        community: 0,
        window: 0,
        man: 0
      },
      discountList: [],
      orderOptions: {},
      send: false,
      sightId: '',
      sightName: '',
      communityKey: '',
      conditionData: null,
      selectedTimeSlots: {
        type: 0,
        typeName: '推荐时段',
        data: []
      },
      isShowConvert: false,
      searchResData: { needDays: 0 },
      cpmAccountNum: '', // 勾选的合计预计流量
      chooseCpmAccountNum: 0,
      allDevices: [],
      searchReqObj: {},
      showIdxS: -1,
      showLen: 8,
      listFillPadding: {
        paddingTop: '0px',
        paddingBottom: '0px'
      },
      showNbhdList: [],
      // _allShowNbhdList: [],
      listMinH: 124,
      showByte: false,

      smartSortType: '1', // 排序radio 默认推荐度优先
      flowType: true, // true 高到低   false 低到高

      isSmartSearch: false,
      smarSortNumRadio: '',  // 智能选取radio 默认''
      smarSortNumType: 'ALL', // 默认全选:ALL/满足总量随机分配:TOTAL/分散投放，指定小区多少台:NBHD_COUNT/分散投放，指定楼幢多少台:BUILDING_COUNT/分散投放，指定单元多少台:NUIT_COUNT
      smartNum: undefined,

      showPkgPop: false,
      speUserGuids: (process.env.VUE_APP_SPEUSERIDS || "").replace(/\s/g, "").split(",")
    }
  },
  computed: {
    isCondition() { //是否是条件筛选
      return this.$store.state.order.conditionSearchTypeName == 'putOrder'
    },
    adUser() { return this.$store.state.customer.userInfo },
    isSpeUser() {
      return this.speUserGuids.length && this.adUser && this.adUser.id && this.speUserGuids.indexOf(this.adUser.id) > -1
    },
    allSelect: {
      get() {
        let allDevices = this.allDevices
        let chooseDeviceL = this.allDevices.filter(el => el.check).length
        return chooseDeviceL == allDevices.length
      },
      set() { }
    },
    allHalf: {
      get() {
        let allDevices = this.allDevices
        let chooseDeviceL = this.allDevices.filter(el => el.check).length
        return chooseDeviceL < allDevices.length && chooseDeviceL > 0
      },
      set() { }
    },
    allChooseNum() {
      let allDevices = this.allDevices
      let chooseDevices = this.allDevices.filter(el => el.check)
      let chooseNbhdGuids = [...new Set(chooseDevices.map(el => el.nbhdGuid))]
      return {
        device: chooseDevices.length,
        nbhd: chooseNbhdGuids.length,
        people: this.communityList.filter(el => chooseNbhdGuids.indexOf(el.guid) > -1).reduce((res, cur) => cur.audienceNumber - 0 + res, 0)
      }
    },
    chooseNbhdNums() {
      let allDevices = this.allDevices
      let chooseDevices = this.allDevices.filter(el => el.check)
      let chooseNbhdGuids = [...new Set(chooseDevices.map(el => el.nbhdGuid))]
      return chooseNbhdGuids.length
    },
    covertDays() {
      let selectSlotRequest = this.searchReqObj.selectSlotRequest
      if (!selectSlotRequest) return 0
      let startDate = selectSlotRequest.startDate, endDate = selectSlotRequest.endDate
      if (endDate) {
        return (new Date(endDate).getTime() - new Date(startDate).getTime()) / (24 * 3600000) + 1
      }
      return this.searchResData.needDays || 0
    },
    cpmLPutLongTime() { // 预计投放时长
      return (this.searchResData.needDays || 0) + '天'
    },
    payWay() {
      return this.$store.state.order.choosePayWay // 'cpd', 'cpmL', 'cpmT', 'pkg'
    },
    isCpm() {
      return this.payWay.indexOf('cpm') > -1
    },
    isCpd() {
      return !this.payWay || this.payWay == 'cpd'
    },
    isSmallSn() { // 是否是小屏投放或小屏导入点位
      let name = this.$store.state.order.conditionSearchTypeName
      return name.toLowerCase().indexOf('smallsn') > -1
    },
    emptyCommunity() {
      return !this.communityList.some(item => {
        return item.visible
      })
    },
    chooseAllMoney() {
      let amountKey = this.payWay.indexOf('cpm') > -1 ? 'flowAmount' : 'amount'
      return this.allDevices.filter(el => el.check).reduce((res, cur) => (cur[amountKey] || 0) - 0 + res, 0)
    },
    discountMoney() {
      let fee = this.chooseAllMoney
      if (this.discountList.length === 0) return fee
      let discount = 1
      this.discountList.forEach(item => {
        if (item.limit < fee && discount > item.sale) discount = item.sale - 0
      })
      let price = discount * fee - 0
      return price
    },
    apiObj() {
      if (this.importType === 'community') {
        return {
          uploadTemplate: '/boss/deviceSlot/v2/exportTemplate?type=1',
          importExcel: '/boss/deviceSlot/v2/importIntelligentNbhd'
        }
      } else if (this.importType === 'smallSnDevice') {
        return {
          uploadTemplate: '/boss/deviceSlot/v2/exportTemplate?type=3',
          importExcel: '/boss/deviceSlot/v2/importIntelligentNbhd?type=3',
          searchUrl: '/boss/deviceSlot/v2/importScreenDevicePut'
        }
      } else {
        return {
          uploadTemplate: '/boss/deviceSlot/v2/exportTemplate?type=3',
          importExcel: '/boss/deviceSlot/v2/importIntelligentNbhd?type=3'
        }
      }
    },
    showSecPage() { // 是否展示二级页面
      return this.send || this.sightId
    },
    pkgChooseMore10() {
      return this.payWay === 'pkg' && this.cpmAccountNum > this.searchReqObj.pkgChooseFlow / 1000 * 1.1
    },
    pkgChooseLess10() {
      return this.payWay === 'pkg' && this.cpmAccountNum < this.searchReqObj.pkgChooseFlow / 1000 * 0.9
    }
  },
  provide() {
    return {
      putOrderProvideData: {
        smartSortType: this.smartSortType
      }
    }
  },
  watch: {
    chooseAllMoney: {
      immediate: true,
      handler(v) {
        this.$nextTick(() => { // 须延迟处理计算
          const tt = setTimeout(() => {
            clearTimeout(tt)
            this.sumData.window = this.allDevices.filter(el => el.check).length
          }, 300)
        })
      }
    },
    showSecPage(v) {
      this.$emit('showConfirm', v)
    },
    isExport(value) {
      this.resetPageInfo(value)
    },
    communityKey(nv) {
      this.filterCommunityData()
    },
    smartSortType(v) {
      this.flowType = true
      this.smartSortChange()
    },
    flowType() {
      this.smartSortChange()
    },
    smarSortNumRadio(v) { // 切换智能选取
      this.smartNum = undefined
      if (v === '1') this.smarSortNumType = 'TOTAL'
      else if (v === '2') this.smarSortNumType = 'NBHD_COUNT' // 分散选取 默认选中第一个按小区
    }
  },
  created() {
    this.getDiscountList()
  },
  beforeDestroy() {
    this.resetSearchStoreCommon()
  },
  methods: {
    initSmart() { // 点击搜索时重置 智能选取 排序优先相关数据
      this.smarSortNumType = 'ALL'
      this.smarSortNumRadio = ''
      this.smartSortType = '1'
      this.flowType = true
      this.smartNum = undefined
    },
    clickSearch(data) {
      if (this.isCondition) this.initSmart()
      this.conditionSearch(data)
    },
    showSight(data) {
      this.sightId = data.id
      this.sightName = data.name
    },
    handleCommunityChange() { // communityList 变化触发方法
      this.sumData.window = 0
      this.sumData.allWindow = 0
      this.communityList.forEach(item => {
        this.sumData.window += item.allSelectDeviceCount
        this.sumData.allWindow += item.allDeviceCount
      })

      this.$nextTick(() => {
        this.handleAllNum()
      })
    },
    handleListScroll() {
      this.showIdxS = -1 // 重置 this.showIdxS 为 -1
      this.$nextTick(() => {
        let listScrollDom = this.$refs.scroll
        if (listScrollDom) {
          listScrollDom.removeEventListener('scroll', this.showGroupList)
          listScrollDom.scrollTop = 0
          listScrollDom.addEventListener('scroll', this.showGroupList)
          this.showGroupList() // 首次执行下展示第一组
        }
      })
    },
    showGroupList() {
      let _allShowNbhdList = this.communityList.filter(el => el.name.indexOf(this.communityKey.trim()) > -1)
      // let _allShowNbhdList = this._allShowNbhdList
      let listMinH = this.listMinH, showLen = this.showLen // showLen 一组
      let listScrollDom = this.$refs.scroll, scrollTop = listScrollDom.scrollTop
      let oneGroupH = listMinH * showLen // 一组的高度
      // 移动一点点就处理组数变化，可以减少 showLen 的数量 渲染更快 每组数量变少滚动时会导致渲染次数增加
      let idx = Math.floor(scrollTop / oneGroupH + 0.95)
      if (idx == this.showIdxS) return
      this.showIdxS = idx
      // 展示第几组的开始索引   0 -> 0/1   1 -> 0/2   2 -> 1/3  3 -> 2/4
      let isIdx0 = idx == 0
      let showGroupIdxS = isIdx0 ? 0 : idx - 1
      // 计算所有列表中展示的收尾起始索引
      let showNbhdIdxS = showGroupIdxS * showLen
      let showNbhdIdxE = Math.min(_allShowNbhdList.length, (showGroupIdxS + (isIdx0 ? 1 : 2)) * showLen)
      if (showNbhdIdxE - showNbhdIdxS < showLen) { // 最后一组数据较少时展示最后长度为showLen的一组元素
        showNbhdIdxS = showNbhdIdxE - showLen
        if (showNbhdIdxS < 0) showNbhdIdxS = 0
      }
      // 改变展示展示列表数据
      this.showNbhdList = _allShowNbhdList.slice(showNbhdIdxS, showNbhdIdxE)
      // 计算padding
      this.listFillPadding = {
        paddingTop: showNbhdIdxS * listMinH + 'px',
        paddingBottom: (_allShowNbhdList.length - showNbhdIdxE) * listMinH + 'px'
      }
      // 0    0 * showLen - 1 * showLen
      // 1    0 * showLen - 2 * showLen
      // 2    1 * showLen - 3 * showLen
    },
    handleAllNum() {
      let tpMap = { 'M1': 'flowAmount', 'M2': 'realAdvFr' }
      let type = 'M2'
      let cpmAccountNum = this.allDevices.filter(el => el.check).reduce((data, cur) => (cur[tpMap[type]] || 0) - 0 + data, 0)
      this.chooseCpmAccountNum = cpmAccountNum
      this.cpmAccountNum = this.handleFlowNumShow(cpmAccountNum)
    },
    handleFlowNumShow(num) {
      // 需求 展示向下取整，不直接四舍五入 toFixed(2) 操作
      const intNum = Math.floor(num / 1000)
      const rest = +((num - intNum * 1000) / 1000 + '').slice(0, 4)
      return (intNum + rest).toFixed(2)
    },
    smartSearch() {
      let num = this.smartNum || ''
      num = (num + '').trim()
      if (!num || num < 1) return this.messageTip('请输入点位数量', 2)
      this.isSmartSearch = true
      this.conditionSearch(this.conditionData, true)
      // this.isSmartSearch = false // 放在搜索完成处理回调之后重置为false
    },
    handleConditionSmartOpt(opt) {
      if (this.smarSortNumRadio != '') { // 智能筛选 生成方案时传参增加
        opt.priority = this.smartSortType
        opt.selectStrategyEnum = this.smarSortNumType
        opt.count = this.smartNum
      }
    },
    async conditionSearch(conditionData, notFromForm, checkReqOpt) {
      let opt = {}, targetFlowData = conditionData.targetFlowData
      if (checkReqOpt) opt = checkReqOpt
      else {
        this.communityKey = '' // 清空列表区域搜索内容
        this.conditionData = conditionData
        let { startDate, endDate, searchTimeRange } = conditionData

        opt = {
          ...conditionData,
          targetFlowOrbudgetAmount: targetFlowData.targetFlowOrbudgetAmount || '',
          selectSlotRequest: {
            endDate: endDate || '', startDate: startDate || '', frequencyList: searchTimeRange || []
          }
        }
        this.searchReqObj = Object.assign({}, opt)
      }
      if (this.isSmartSearch) { // 条件搜索的智能选取生成方案 增加传参
        this.handleConditionSmartOpt(opt)
      }

      delete opt.originPerson
      delete opt.targetFlowData
      delete opt.searchTimeRange

      if (this.smartSortType == 3) opt.flowDensitySort = !this.flowType

      let loading = this.$loading()
      let url = '/boss/deviceSlot/v2/getAllDevice300Map'
      if (this.isSmallSn) url = '/boss/deviceSlot/v2/getSmallScreenPut'
      let res = await this.fetch(url, opt)

      const tt = setTimeout(() => {
        clearTimeout(tt)
        loading.close()
      }, 500)

      /*
       * bus 广播告知点击搜索点位操作
       * 后续 确认变更的搜索条件需要展示在确认订单页面的 可以不统一放在 setStoreSearchForConfirm 里处理
       * 因为各个层级组件数据传递到最外部父级这里 setStoreSearchForConfirm 调用较麻烦，需要做挺多额外传参参数数据惭怍
       * 方案：这里点击搜索完成后 统一 bus 广播 pointSearchClick 事件，告知各层级子组件 监听 $on('pointSearchClick') 操作处理数据保存到store中
       * 各个层级子组件本身数据不需要传递到最外部此处，简洁方便，数据操作维护到各个子组件内 好维护，后续增加其他条件也无须更改这里的
       */
      this.$root.$emit('pointSearchClick')

      // 勾选check状态改变时 直接返回结果
      if (checkReqOpt) {
        if (res && res.code === 900501) {
          this.messageTip(res.message)
          return
        }
        // 可勾选的天数可能会变化， 这里重新处理每个小区的days数据
        this.handleCheckReqList((res.data || {}).data || [])
        return res
      }
      if (res && res.code === 0 && res.data) {
        if (res.data.scheduleMessage !== null) {
          const confirmFlag = await this.$confirm(res.data.scheduleMessage, '排期校验', {
            confirmButtonText: '继续投放',
            cancelButtonText: '取消'
          }).then(res => {
            return true
          }).catch(err => {
            return false
          })
          if(!confirmFlag) return
        }
        this.setStoreSearchForConfirm(conditionData) // 请求成功之后再更新相关store数据 供确认订单准确使用
        let resData = res.data || {}
        this.showByte = resData.dataAuth
        this.searchResData = resData
        let searchList = resData.data || []
        if (searchList.length == 0) this.messageTip('暂无数据', 2)
        if (this.isCondition) this.initSmartSort(searchList) // 数据搜索完 来回切换 推荐度和空刊优先时 返回推荐度优先和默认数据返回排序不一致  这里提前根据空刊排序后再对数据进行默认推荐度排序
        this.communityList = this.handleListData(searchList)
        this.handleCommunityChange()

        // 变化列表选中状态相关处理
        if (!this.isSmartSearch) {
          let { chooseLabel, targetFlowOrbudgetAmount } = targetFlowData
          // // cpm 按 精准流量 M2 按照接口返回的 accurateFlow 勾选列表
          // if (conditionData.orderLabels && conditionData.orderLabels.indexOf('M2') > -1) targetFlowOrbudgetAmount = res.data.accurateFlow || 0
          this.$nextTick(() => { this.handleTargetChoose(targetFlowOrbudgetAmount, chooseLabel) })
        }
        if (this.payWay === 'pkg') { // 套餐兑换 列表勾选选取套餐码对应得流量数据点位  M2 代表按流量勾选
          this.$nextTick(() => { this.handleTargetChoose(this.searchReqObj.pkgChooseFlow / 1000, ['M2'], true) })
        }

        // 更新所有点位数据
        this.handleAllDevices()
        // 大数据量全部展示以及勾选会出现卡顿问题处理
        this.handleShowNbhdList(this.communityList)

        // 搜索结果store数据变换
        this.setResStoreData(resData)
        // // 如果是点击搜索按钮的搜索 不是切换时间的请求
        // if (!notFromForm) {
        //   this.resetTimeSlot(resData) // 投放时段移到左侧搜索部位 此处暂不用reset了
        // }
      } else if (res.code === 900501) {
        this.messageTip(res.message)
      }

      if (this.isSmartSearch) this.isSmartSearch = false // 可能智能选取的生成方案搜索，这里处理完回调之后再重置为false 一些数据处理方法需要用到 isSmartSearch 的状态
    },
    initSmartSort(data) {
      window.$listCopy = deepClone(data || [])

      // 保证切换之后的推荐度排序和第一次搜索的推荐度排序顺序展示一致, 在先执行下空刊排序数据的基础上推荐度排序 来回切换时可以保证顺序一致
      // 输入数量选取后有问题 勾选的小区可能就不连续，推荐度优先还展示后端展示顺序
      // data.sort((a, b) => {
      //   if (a.emptySaleRate == b.emptySaleRate) return b.nbhdFlowNum - a.nbhdFlowNum
      //   else return b.emptySaleRate - a.emptySaleRate
      // })
      // data.sort((a, b) => b.match - a.match)
    },
    smartSortChange() { // 智能排序 默认
      let tp = this.smartSortType
      if (tp == 1) {
        // 按照后端返回的数据 切换到 空刊优先再切换回推荐度优先 数据顺序变化过两次 可能不会和后端返回一致 这里推荐度直接再次取后端返回的数据展示
        const tList = Object.assign([], window.$listCopy)
        this.communityList = tList.sort((a, b) => b.match - a.match)
      } else if (tp == 2) {
        this.communityList.sort((a, b) => {
          return b.emptySaleRate - a.emptySaleRate
        })
      } else if (tp == 3) {
        this.communityList.sort((a, b) => {
          let upToLow = this.flowType
          return upToLow ? b.flowPerPoint - a.flowPerPoint : a.flowPerPoint - b.flowPerPoint
        })
      }
      this.handleShowNbhdList(this.communityList)

      this._provided.putOrderProvideData.smartSortType = tp // provide中数据更新
    },
    setResStoreData(resData) {
      // 推荐时段
      this.$store.commit('setStoreData', { key: 'recommendTimeSlotData', value: resData.frequencyList || [] })
    },
    async resetTimeSlot(resData) {
      this.$store.commit('setStoreData', { key: ['chooseTimeSlot', 'idx'], value: 0 })
      this.selectedTimeSlots.data = await this.fillFrequencyNames(resData.frequencyList || [])
      this.selectedTimeSlots.type = 0
      this.selectedTimeSlots.typeName = '推荐时段'
    },
    handleCheckReqList(list) { // 可勾选的天数可能会变化， 这里重新处理每个小区的days数据
      if (!list || !list.length) return
      let listGuids = list.map(el => el.guid)
      let communityListGuids = this.communityList.map(el => el.guid)
      communityListGuids.forEach((el, i) => {
        let idx = listGuids.indexOf(el)
        if (idx > -1) {
          this.communityList[i] = this.fillItemKey({ ...list[idx], visible: true }, false, true)
          // this.$set(this.communityList, i, this.fillItemKey({ ...list[idx], visible: true }, false, true))
        }
      })
      this.$forceUpdate()
      this.handleShowNbhdList(this.communityList)
      // 新的device是新的内存对象不会联动，须重新计算下当前的所有设备
      this.handleAllDevices()
      this.handleAllNum()
    },
    handleAllDevices(list, needReturn) {
      list = list || this.communityList
      let arr = []
      let handleNbhdDeviceList = (array, item, type) => {
        for (let j = 0; j < array.length; j++) {
          let units = array[j].unitDeviceList || []
          for (let z = 0; z < units.length; z++) {
            let devices = units[z].deviceList || []
            for (let k = 0; k < devices.length; k++) {
              let de = devices[k]
              de.typeSn = type // 1 梯内的屏 2 梯外屏
              de.nbhdGuid = item.guid
              arr.push(de)
            }
          }
        }
      }
      for (let i = 0; i < list.length; i++) {
        let nbhd = list[i]
        handleNbhdDeviceList(nbhd.buildDeviceList || [], nbhd, 1)
        handleNbhdDeviceList(nbhd.twBuildDeviceList || [], nbhd, 2)
      }
      if (needReturn) return arr
      this.allDevices = arr
    },
    handleTargetChoose(num, labelKey, isPkg) {
      if (this.isExport) return // 导入的默认选择不做 handleTargetChoose 处理
      if (!num || (num + '').trim() == '') return
      if (!labelKey || !labelKey.length) return

      // M1 预算总额 M2 目标流量     --->   M1 触达总量  M2 精准流量
      // 用于下面的  keyMap  vKey 来确定数据取哪个字段的值进行处理   预算总额去掉之后  只需考虑流量相关的字段 tnSelectDeviceFlow  realAdvFr
      // labelKey = labelKey[0]
      labelKey = 'M2' // 此处配置为 'M2' 代表 流量相关
      if (labelKey == 'M2') num = (num - 0) * 1000

      let keyMap = { 'M1': 'allSelectSlotAmount', 'M2': 'tnSelectDeviceFlow' }
      let values = this.communityList.map(el => el[keyMap[labelKey]])
      // console.log(num)
      // console.log(values)
      let idx = 0, i = 0
      for (i = 0; i < values.length; i++) {
        let addBefore = values[i] + (i > 0 ? values[i - 1] : 0)
        values[i] = addBefore
        idx = i;
        if (values[i] > num) break;
      }
      // values 循环完毕后 i 会自增一个   此时说明全部价格都小于输入价格 和默认的全选状态一致都是选中，后续无须执行
      if (i > idx) return
      this.communityList.forEach((el, j) => {
        if (j >= idx) {
          // 整体设置 this.communityList 第 i 个元素 可以出发 communityList 的 watch 的一些列操作， 需把子集的check状态也同时改掉
          el.checked = false
          // el.allSelectDeviceCount = 0
          // el.allSelectSlotAmount = 0
          this.changeCommunityHandler(el, true) // 更新子集的勾选状态
        }
      })

      if (num == 0) return // 取消勾选之后 输入0时 不做后续的增加选中逻辑 一个都不选

      this.$nextTick(() => {
        let isNoChooseOne = false
        if (idx == 0 && i == 0) isNoChooseOne = true // 第一个小区需要半选的情况 => 输入的钱数少于第一个小区的总价的时候
        if (isNoChooseOne || values[idx - 1] < num) { // 选取的不足时，点位级别再多选中一些
          if (this.communityList[idx]) {
            let partNbhd = this.communityList[idx]
            let nbhdAllDevices = this.handleAllDevices([partNbhd], true)
            let nbhdNumData = isNoChooseOne ? 0 : values[idx - 1] - 0
            let vKey = { 'M1': 'flowAmount', 'M2': 'realAdvFr' }
            for (let i = 0; i < nbhdAllDevices.length; i++) {
              let curDe = nbhdAllDevices[i]
              curDe.check = true
              let newV = (curDe[vKey[labelKey]] - 0).toFixed(2) - 0
              nbhdNumData = nbhdNumData + newV
              if (nbhdNumData > num) break;
            }
            partNbhd.allSelectDeviceCount = nbhdAllDevices.filter(el => el.check).length
            partNbhd.allSelectSlotAmount = nbhdAllDevices.filter(el => el.check).reduce((res, cur) => ((isPkg ? cur.amount : cur.flowAmount) - 0).toFixed(2) - 0 + res, 0)

            partNbhd.checked = partNbhd.allSelectDeviceCount == nbhdAllDevices.length
              ; (partNbhd.buildDeviceList || []).forEach(el => {
                let sltDeCount = 0, sltDeAmount = 0
                  ; (el.unitDeviceList || []).forEach(ele => {
                    ; (ele.deviceList || []).forEach(elem => {
                      if (elem.check) {
                        sltDeCount += 1
                      }
                    })
                  })
                el.selectDeviceCount = sltDeCount
                el.check = sltDeCount == el.allDeviceCount
              })
              ; (partNbhd.twBuildDeviceList || []).forEach(el => {
                let sltDeCount = 0, sltDeAmount = 0
                  ; (el.unitDeviceList || []).forEach(ele => {
                    ; (ele.deviceList || []).forEach(elem => {
                      if (elem.check) {
                        sltDeCount += 1
                      }
                    })
                  })
                el.selectDeviceCount = sltDeCount
                el.check = sltDeCount == el.allDeviceCount
              })
          }
        }
      })
    },
    async fillFrequencyNames(data) {
      if (!data || data.length == 0) return []
      let allTimeRanges = this.$store.state.bmap.allTimeRanges
      if (!allTimeRanges || allTimeRanges.length == 0) {
        await this.$store.dispatch('getTimeRanges')
        allTimeRanges = this.$store.state.bmap.allTimeRanges
      }
      let ids = allTimeRanges.map(el => el.guid)
      return data.map(el => {
        let idx = ids.indexOf(el.frequencyTime)
        if (idx > -1) el.frequencyName = allTimeRanges[idx].frequencyName
        else el.frequencyName = '未知'
        return el
      })
    },
    handleListData(arr, isExport) {
      for (let i = 0; i < arr.length; i++) {
        this.fillItemKey(arr[i], isExport)
      }
      return arr
    },
    fillItemKey(item, isExport, cpmCheckReq) {
      item.visible = true

      // 默认缺货也全选相关改动
      // item.allSelectDeviceCount = item.twAllDeviceCount + item.tnAllDeviceCount
      // item.allSelectSlotAmount = item.twAllSlotAmount + item.tnAllSlotAmount
      this.$set(item, 'allSelectDeviceCount', item.twAllDeviceCount + item.tnAllDeviceCount)
      this.$set(item, 'allSelectSlotAmount', item.twAllSlotAmount + item.tnAllSlotAmount)

      if (isExport || cpmCheckReq || this.isSmartSearch) {
        item.allSelectDeviceCount = item.twSelectDeviceCount + item.tnSelectDeviceCount
        item.allSelectSlotAmount = item.twSelectSlotAmount + item.tnSelectSlotAmount
      }

      item.allDeviceCount = item.twAllDeviceCount + item.tnAllDeviceCount

      item.checked = item.allSelectDeviceCount != 0 && item.allSelectDeviceCount == item.tnSelectDeviceCount + item.twSelectDeviceCount

      // 默认缺货也全选相关改动
      // (cpm定量搜索 导入搜索 智能选取) 这几种情况都不默认全选
      if (!cpmCheckReq && !isExport && !this.isSmartSearch) {
        item.checked = true
        this.changeChildCheck(item)
      }
      return item
    },
    addKeyupEvent() {
      this.$refs['search-community'].$el.addEventListener('keyup', e => {
        if (e.code === 'Enter') {
          this.filterCommunityData()
        }
      })
    },
    handleExportReqOpt({ condition, result }) {
      let {
        startDate, endDate, targetFlowData, searchTimeRange, contentTime, clienteleName,
        packageInfoCodes, pkgChooseFlow
      } = condition || {};
      targetFlowData = targetFlowData || {}
      return {
        ...condition,
        nbhdSearchMapResponse: result,
        selectSlotRequest: { startDate: startDate || '', endDate: endDate || '', frequencyList: searchTimeRange || [] },
        contentTime,
        targetFlowOrbudgetAmount: targetFlowData.targetFlowOrbudgetAmount || '',
        clienteleName: clienteleName ? clienteleName.trim() : '',
        packageInfoCodes,
        pkgChooseFlow: pkgChooseFlow || ''
      }
    },
    async importExcelReq({ condition, result }, checkReqOpt) {
      let opt = null
      if (checkReqOpt) opt = checkReqOpt
      else {
        if (result.length <= 0) return false
        this.searchCondition = condition
        opt = this.handleExportReqOpt({ condition, result })
        this.searchReqObj = Object.assign({}, opt)
      }
      if (this.importType.toLowerCase().indexOf('device') > -1) {
        delete opt.targetFlowData
        delete opt.searchTimeRange
        const url = this.apiObj.searchUrl ? this.apiObj.searchUrl : '/boss/deviceSlot/v2/getDeviceSlotByExcel'
        let res = await this.fetch(url, opt, 'POST')
        return this.handleExportReqFinish(condition, res, checkReqOpt)
      }
      return this.handleExportReqFinish(condition, await getIntelligentDeviceByExcel(opt), checkReqOpt)
    },
    handleExportReqFinish(condition, res, checkReqOpt) { // 导入小区、点位完成处理
      this.$root.$emit('pointSearchClick') // bus 广播告知点击搜索点位操作
      if (res && res.code === 900501) {
        this.resetPageInfo()
        return this.messageTip(res.message || '导入搜索失败')
      }
      if (!res || res.code != 0) {
        return
      }
      if (res.data.scheduleMessage !== null) {
        this.$confirm(res.data.scheduleMessage, '排期校验', {
          confirmButtonText: '继续投放',
          cancelButtonText: '取消'
        }).then(_res => {

          // cpm按流量请求处理
          if (checkReqOpt) {
            this.handleCheckReqList((res.data || {}).data || [])
            return res
          }
          this.setStoreSearchForConfirm(condition)
          // 正常请求列表处理
          let data = res && res.data || {}
          this.searchResData = data
          this.excelResult.successCount = data.successCount || 0
          this.excelResult.failCount = data.failCount || 0
          this.excelResult.shortageCount = data.shortageCount || 0

          let list = data.data || []
          if (list.length === 0) this.messageTip('暂无数据', 2)

          this.communityList = this.handleListData(list, true)
          this.handleCommunityChange()
          // 更新所有点位数据
          this.handleAllDevices()
          // 大数据量全部展示以及勾选会出现卡顿问题
          // 部分展示 滚动替换当前展示区域内容 减少整体dom展示
          this.handleShowNbhdList(this.communityList)

          this.uuid = data.uuid
          this.$store.commit('setStoreData', { key: 'searchPointChooseLabels', value: condition.labelList })
        }).catch(err =>{})
      } else {
        // cpm按流量请求处理
          if (checkReqOpt) {
            this.handleCheckReqList((res.data || {}).data || [])
            return res
          }
          this.setStoreSearchForConfirm(condition)
          // 正常请求列表处理
          let data = res && res.data || {}
          this.searchResData = data
          this.excelResult.successCount = data.successCount || 0
          this.excelResult.failCount = data.failCount || 0
          this.excelResult.shortageCount = data.shortageCount || 0

          let list = data.data || []
          if (list.length === 0) this.messageTip('暂无数据', 2)

          this.communityList = this.handleListData(list, true)
          this.handleCommunityChange()
          // 更新所有点位数据
          this.handleAllDevices()
          // 大数据量全部展示以及勾选会出现卡顿问题
          // 部分展示 滚动替换当前展示区域内容 减少整体dom展示
          this.handleShowNbhdList(this.communityList)

          this.uuid = data.uuid
          this.$store.commit('setStoreData', { key: 'searchPointChooseLabels', value: condition.labelList })
      }
    },
    // 投放小区订单
    sendOrder() {
      let isExport = this.isExport
      let chooseDevices = this.allDevices.filter(el => el.check)
      let chooseNbhdGuids = [...new Set(chooseDevices.map(el => el.nbhdGuid))]
      let chooseCmS = this.communityList.filter(el => chooseNbhdGuids.indexOf(el.guid) > -1)
      if (chooseDevices.length === 0) return this.messageTip('请勾选小区点位')
      // 2024-09-05 勾选单个小区，出现超库存报错，点击立即投放也报错提示不让进入确认订单页
      if (this.searchResData.needDays === 0) return this.messageTip('搜索日期超出库存限制!')
      if (isExport) {
        this.handleConfirmData(chooseCmS)
      } else {
        this.$store.commit('setSearchDetail', this.communityList)
      }
      this.orderOptions = {
        type: isExport ? 'excelImport' : 'condition',
        data: chooseCmS,
        isExport,
        conditionData: this.searchReqObj,
        needDays: this.searchResData.needDays,
        cpmAccountNum: this.cpmAccountNum,
        searchChargeWay: this.payWay,
      }

      if (this.payWay === 'pkg' && (this.pkgChooseMore10 || this.pkgChooseLess10)) {
        this.showPkgPop = true
      } else {
        this.send = true
      }
    },
    handleConfirmData(chooseCmS) { // 处理excel上传导入确认订单页面需要数据
      let { startDate, endDate, contentTime } = this.searchCondition
      this.$store.commit('setStoreData', { key: ['mapSearchOptions', 'contentTime'], value: contentTime })
      this.$store.commit('setStoreData', { key: ['mapSearchOptions', 'time'], value: [startDate, endDate] })
      this.$store.commit('setSearchDetail', this.communityList)
    },
    async getNbhdExcelByCondition() { // 新版智能快速查看小区接口
      this.importResultVisible = true
    },
    uploadProgress({ name, progress }) {
      this.fileObj = { name, progress }
    },
    filterCommunityData() {
      this.handleShowNbhdList()
    },
    handleShowNbhdList(list) {
      // this._allShowNbhdList = list.filter
      this.showNbhdList = []
      this.handleListScroll()
    },
    changeCommunityHandler(item, isAuto) {
      let checked = item.checked
      this.$nextTick(() => {
        item.allSelectSlotAmount = checked ? item.tnAllSlotAmount + item.twAllSlotAmount : 0
        item.allSelectDeviceCount = checked ? item.allDeviceCount : 0
        item.tnSelectDeviceCount = checked ? item.tnAllDeviceCount : 0
        item.tnSelectSlotAmount = checked ? item.tnAllSlotAmount : 0
        item.twSelectDeviceCount = checked ? item.twAllDeviceCount : 0
        item.twSelectSlotAmount = checked ? item.twAllSlotAmount : 0

        this.changeChildCheck(item)
        this.handleCommunityChange()

        if (!isAuto && this.payWay == 'cpmL') { // 如果是cpmL按流量模式 重新请求展示更新天数数据  isAuto是点击搜索整体搜索整体的变化不重新请求
          this.checkChangeReq()
        }
      })
    },
    childChangeReq() { // 子组件勾选确定之后 如果是cpmL按流量模式 重新请求展示更新天数数据
      this.handleCommunityChange()
      this.handleAllDevices() // 子组件数据和community不是对象引用，不会同步allDevices  这里重新计算下
      if (this.payWay == 'cpmL') {
        this.checkChangeReq()
      }
    },
    changeChildCheck(item) { // 小区状态改变后，改变小区子集幢 单元 设备的check状态
      let check = item.checked
      let handleListCheck = (list, check) => {
        for (let i = 0; i < list.length; i++) {
          let nbhd = list[i]
          if (nbhd.check != check) nbhd.check = check
          for (let j = 0; j < nbhd.unitDeviceList.length; j++) {
            let unit = nbhd.unitDeviceList[j]
            if (unit.check != check) unit.check = check
            for (let z = 0; z < unit.deviceList.length; z++) {
              let device = unit.deviceList[z]
              if (device.check != check) device.check = check
            }
          }
        }
      }
      handleListCheck(item.buildDeviceList || [], check)
      handleListCheck(item.twBuildDeviceList || [], check)
    },
    async checkChangeReq() {
      if (this.allDevices.filter(el => el.check).length == 0) { // 全不选cpm按流量请求，这里强制展示为0， 不请求接口数据了
        this.searchResData.needDays = 0
        return
      }
      let conditionSearchTypeName = this.$store.state.order.conditionSearchTypeName
      let noSelectnbhdDeviceGuidsMap = {}, arr = []
      let list = this.allDevices.filter(el => el.check) // cpmL  noSelectnbhdDeviceGuidsMap 改成传所有选择的点位
      list.forEach(el => {
        let idx = arr.map(ele => ele.key).indexOf(el.nbhdGuid)
        if (idx == -1) {
          arr.push({ key: el.nbhdGuid, value: [el.deviceGuid] })
        } else {
          arr[idx].value.push(el.deviceGuid)
        }
      })
      arr.forEach(el => {
        noSelectnbhdDeviceGuidsMap[el.key] = el.value
      })
      let opt = {
        ...this.searchReqObj,
        noSelectnbhdDeviceGuidsMap
      }

      // cpm流量勾选请求的只处理展示 needDays 变化
      let res
      if (conditionSearchTypeName == 'putOrder') { // 条件筛选
        res = await this.conditionSearch({}, false, opt)
      } else {
        res = await this.importExcelReq({}, opt)
      }
      if (res && res.code == this.successCode) {
        this.searchResData = res.data || {}

        if (this.allDevices.filter(el => el.check).length == 0) { // 全不选cpm按流量请求 后端返回有问题，这里强制展示为0
          this.searchResData.needDays = 0
        }
      }

      this.handleCommunityChange()
    },
    changeAllSelectHandler(status) {
      // 底部全选如果是半选状态时 点击它 置为 false
      if (status && this.allHalf) status = false
      else if (!status && !this.allSelect) status = true

      this.communityList.forEach((item, i) => {
        item.checked = status
        item.allSelectSlotAmount = status ? item.tnAllSlotAmount + item.twAllSlotAmount : 0
        item.allSelectDeviceCount = status ? item.allDeviceCount : 0
        item.tnSelectDeviceCount = status ? item.tnAllDeviceCount : 0
        item.tnSelectSlotAmount = status ? item.tnAllSlotAmount : 0
        item.twSelectDeviceCount = status ? item.twAllDeviceCount : 0
        item.twSelectSlotAmount = status ? item.twAllSlotAmount : 0
        item.selectDeviceCount = status ? item.allDeviceCount : 0
        this.changeChildCheck(item)
      })
      this.handleCommunityChange()
      this.handleShowNbhdList(this.communityList)
      if (this.payWay == 'cpmL') { // 如果是cpmL按流量模式 重新请求展示更新天数数据
        this.checkChangeReq()
      }
    },
    async getDiscountList() {
      let storeDiscountList = this.$store.state.common.discountList
      if (!storeDiscountList || storeDiscountList.length == 0) {
        await this.$store.dispatch('getDiscountList')
        storeDiscountList = this.$store.state.common.discountList
      }
      this.discountList = storeDiscountList
    },
    resetPageInfo(value) {
      this.communityList = []
      this.handleCommunityChange()
      this.showNbhdList = []
      // this._allShowNbhdList = []
      this.allDevices = []
      this.selectedTimeSlots.data = []
      this.communityKey = ''
      this.$store.commit('setStoreData', { key: 'recommendTimeSlotData', value: [] })
    }
  }
}
</script>

<style lang="scss" scoped>
.put_import_container {
  position: relative;
  height: calc(100% - 50px);
  margin: 0 2px;

  &.full_page {
    height: 100%;
  }
}

.pkgpop_main {
  width: 310px;
  margin: 25px auto;
  text-align: center;
  font-size: 16px;

  span {
    color: #FF3973;
  }
}

.sec_page {
  // height: calc(100% + 50px);
  height: 100%;
}

.convert {
  color: #6296FF;
  margin-left: 20px;
  cursor: pointer;
  font-size: 12px;
}

.r_header {
  border-top: 1px solid #d4d4d4;
  border-bottom: 1px solid #d4d4d4;
  position: relative;
  top: -1px;
  height: 40px;
  overflow: hidden;

  .smart_sort {
    float: left;
    margin-left: 20px;
    font-weight: 550;

    i {
      font-size: 10px;

      &.flow {
        cursor: pointer;
        position: relative;
        left: -25px;
        top: -2px;
      }

      span {
        color: #000;
        font-size: 14px;
        font-weight: bold;
      }

      .grey {
        color: #bbb;
      }
    }
  }
}

.p_i_left {
  position: absolute;
  z-index: 0;
  left: 0;
  top: 0;
  bottom: 0;
  width: 360px;
  box-shadow: -1px 0 0 0 #e9e9e9 inset;
  overflow: auto;

  ::v-deep .el-form-item__label {
    font-weight: 700;
  }
}

.p_i_right {
  position: relative;
  height: 100%;
  margin-left: 360px;
  overflow-y: auto;
}

.p_i_result {
  height: 100%;
  min-width: 635px;
}

.import_img {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 300px;
  height: 210px;
  margin-top: -105px;
  margin-left: -150px;
  cursor: pointer;
}

.r_b_search {
  position: relative;
  line-height: 40px;

  .s_input {
    position: relative;
    z-index: 1;
    background: #fff;
    display: inline-block;
    width: 220px;
    border-right: 1px solid #E9E9E9;
    transition: all .8s;

    &.is_condition {
      box-shadow: 2px 0px 10px 0px rgba(255, 57, 115, 0.2), -1px 0px 0px 0px rgba(233, 233, 233, 1), 0px 1px 0px 0px rgba(255, 57, 115, 1);
      float: right;
    }

    &.no-time {
      width: 300px;

      &.highlight {
        width: 380px;

        .search_text {
          opacity: 1;
        }
      }
    }

    &.highlight {
      width: 300px;

      .search_text {
        opacity: 1;
      }
    }

    .search_text {
      display: inline-block;
      opacity: 0;
      width: 24px;
      font-size: 12px;
      vertical-align: middle;
      cursor: pointer;
      color: #999;
    }

    .el-input {
      display: inline-block;
      width: calc(100% - 34px);
    }

    ::v-deep .el-input__inner {
      font-size: 12px;
      padding-left: 40px;
      border: none;
    }

    ::v-deep .el-input__prefix {
      left: 18px;
    }

    ::v-deep .iconfont {
      font-size: 16px;
    }

    ::v-deep .el-input__suffix-inner {
      position: relative;
      top: 1px;
    }
  }

  .s_msg {
    display: inline-block;
    padding-right: 20px;
    font-size: 14px;
    line-height: 20px;
    border-right: 1px solid #E9E9E9;

    .hl {
      color: #3083F2;
      font-style: normal;
    }
  }

  .s_button {
    margin-left: 20px;
    margin-right: 20px;
    color: #878A92;
    font-size: 14px;
  }
}

.r_b_ul.empty::after {
  display: block;
  margin: 10px;
  padding: 52px;
  content: '暂无结果，换个名称重新试试吧~';
  color: #999;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  background-color: #F5F5F5;
}

.r_b_list {
  min-height: 124px;
  padding-left: 20px;
  margin-left: 0;
  width: 100%;
  box-shadow: 0 -1px 0 0 #e9e9e9 inset;

  ::v-deep .el-checkbox__label {
    vertical-align: middle;
    width: calc(100% - 13px);
  }

  &:hover {
    background: #E9E9E9;

    ::v-deep .label_item {
      background: #FFF;
    }
  }
}

.community_outer {
  vertical-align: middle;
  margin-left: 12px;
  width: calc(100% - 26px);
}

.r_body {
  height: calc(100% - 100px);
  overflow-y: auto;
  overflow-x: hidden;

  &.is_condition {
    height: calc(100% - 140px);
  }
}

.sort_num {
  border-top: 1px solid #e9e9e9;
  position: relative;
  top: -1px;
  line-height: 40px;
  background: #FBFBFB;
  padding: 0 20px;
  font-size: 12px;

  .sort_btn {
    cursor: pointer;
    color: #FF3973;
    margin-left: 15px;
  }

  ::v-deep .el-input-number {
    width: 80px;
    margin-right: 10px;

    input {
      text-align: left;
    }

    >span {
      width: 20px;
    }

    .el-input__inner {
      padding-right: 0;
      padding-left: 10px;
    }
  }

  ::v-deep .el-select {
    position: relative;
    z-index: 1;

    // margin-right: 10px;
    input {
      width: 36px;
      text-align: left;
      padding: 0;
      padding-right: 10px;
      border: none;
      background: none;
      color: #7825FA;
    }

    .el-input__icon {
      display: none;
    }
  }

  .el-icon-caret-bottom {
    color: #7825FA;
    margin-right: 5px;
    position: relative;
    z-index: 0;
    left: -9px;
  }
}

.r_footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: grid;
  grid-template-columns: 84px auto 160px;
  grid-template-rows: 32px 28px;
  grid-auto-flow: column;
  align-items: center;
  background-color: #fff;
  box-shadow: 0 -1px 0 0 #E9E9E9;
  z-index: 1;

  .el-checkbox {
    grid-row: 1 / 3;
    margin-left: 20px;
  }

  .r_checkbox_label {
    font-size: 14px;
  }

  .f_import_button {
    grid-row: 1 / 3;
    color: #fff;
    width: 120px;
    height: 40px;
    margin-left: 20px;
    font-size: 14px;
    background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%);
    border-radius: 4px;
    border: none;
  }

  .r_f_price {
    padding-top: 7px;
    line-height: 25px;
    font-family: Akrobat;

    .hl {
      font-size: 20px;
      font-weight: 800;
    }

    .del {
      margin-left: 10px;
      color: #666666;
      font-size: 14px;
      line-height: 17px;
      text-decoration: line-through;
    }
  }

  .r_f_msg {
    padding-bottom: 6px;
    color: #999;
    font-size: 14px;
    line-height: 20px;
  }

  .hl {
    color: #FF3973;
    font-size: 16px;
    line-height: 20px;
    font-weight: bold;
  }

  .dark {
    color: #282729;
    font-size: 14px;
    line-height: 20px;
  }
}

em {
  font-style: normal;
}

.progress_box {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 400px;
  height: 64px;
  margin-left: -200px;
  margin-top: -32px;
  padding: 20px;
  border: 1px solid #D4D4D4;
  border-radius: 4px;

  .file_name {
    color: #666;
    font-size: 12px;
    line-height: 17px;

    .iconfont {
      margin-right: 6px;
      vertical-align: middle;
    }
  }

  ::v-deep .el-progress-bar {
    padding-right: 0;
    margin-right: 0;
  }

  ::v-deep .el-progress__text {
    position: absolute;
    right: 0;
    top: -100%;
    color: #FF3973;
  }

  ::v-deep .el-progress-bar__inner {
    background-color: #FF3973;
  }

  ::v-deep .el-progress-bar__outer {
    height: 3px !important;
  }

  .close_btn {
    position: absolute;
    right: -34px;
    top: 50%;
    width: 24px;
    height: 24px;
    margin-top: -12px;
    color: #282729;
    text-align: center;
    line-height: 24px;
    border-radius: 50%;
    border: 1px solid #D4D4D4;
    cursor: pointer;
  }
}
</style>
